import React, { useState } from "react";
import Avatar from "./Avatar";
import logo from "../../assets/images/clientlogo.png";
import whiteLogo from "../../assets/images/whiteTeamslogo.png";
import Transition from "./Transition";
import { Link } from "react-router-dom";

const NavBar = ({ avatarurl }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [hidden, setHidden] = useState(false);
  const aName = localStorage.getItem("agentName");

  const handleClick = () => {
    if (isOpen) {
      setIsOpen(false);
      setHidden(false);
    } else {
      setIsOpen(true);
      setHidden(true);
    }
  };

  const optionSelection = (option) => {
    if (option === "request") {
      setIsOpen(false);
      setHidden(false);
    }
  };
  return (
    <nav className="z-30 relative bg-white border-b border-gray-200 dark:bg-white/10 dark:text-white dark:border-gray-600">
      <div className=" mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex">
            <div className="flex items-center">
              <Link
                to="/dashboard"
                onClick={() => optionSelection("request")}
                className="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 dark:hover:bg-white/10"
              >
                <img
                  className="h-8 w-auto block dark:hidden"
                  src={logo}
                  alt="Workflow logo"
                />
                <img
                  className="h-8 w-auto hidden dark:block"
                  src={whiteLogo}
                  alt="Workflow logo"
                />
              </Link>
            </div>
          </div>
          <div className="flex">
            <div className="flex-shrink-0 flex items-center text-xl font-semibold tracking-wider">
              {localStorage.getItem("agentName")}
            </div>
          </div>
          <div className="hidden sm:ml-6 sm:flex sm:items-center">
            <div className="flex items-center">
              <button
                onClick={() => {
                  document.documentElement.classList.toggle('dark');
                  localStorage.theme = document.documentElement.classList.contains('dark') ? 'dark' : 'light';
                }}
                className="p-2 rounded-full bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700 transition"
                title="Toggle Theme"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5 hidden dark:block"
                  fill="currentColor"
                  viewBox="0 0 4000 4000"
                >
                  <path d="M2000 1320A680 680 0 102000 2680 680 680 0 102000 1320zM2000 1047.95c-75.105 0-136-60.895-136-136V776c0-75.105 60.895-136 136-136s136 60.895 136 136v135.95C2136 987.056 2075.105 1047.95 2000 1047.95zM2769.383 1366.634c-34.797 0-69.594-13.265-96.156-39.811-53.125-53.092-53.125-139.204-.066-192.329l96.09-96.14c53.125-53.125 139.254-53.142 192.379-.05s53.125 139.204.066 192.329l-96.09 96.14C2839.043 1353.353 2804.18 1366.634 2769.383 1366.634zM3224 2136h-135.934c-75.105 0-136-60.895-136-136s60.895-136 136-136H3224c75.105 0 136 60.895 136 136S3299.105 2136 3224 2136zM2865.473 3001.506c-34.797 0-69.66-13.281-96.223-39.86l-96.09-96.14c-53.059-53.125-53.059-139.237.066-192.329s139.254-53.108 192.379.05l96.09 96.14c53.059 53.125 53.059 139.237-.066 192.329C2935.066 2988.241 2900.27 3001.506 2865.473 3001.506zM2000 3360c-75.105 0-136-60.895-136-136v-135.95c0-75.105 60.895-136 136-136s136 60.895 136 136V3224C2136 3299.105 2075.105 3360 2000 3360zM1134.527 3001.506c-34.797 0-69.594-13.265-96.156-39.811-53.125-53.092-53.125-139.204-.066-192.329l96.09-96.14c53.125-53.158 139.254-53.142 192.379-.05s53.125 139.204.066 192.329l-96.09 96.14C1204.188 2988.208 1169.324 3001.506 1134.527 3001.506zM911.934 2136H776c-75.105 0-136-60.895-136-136s60.895-136 136-136h135.934c75.105 0 136 60.895 136 136S987.039 2136 911.934 2136zM1230.617 1366.634c-34.797 0-69.66-13.281-96.223-39.86l-96.09-96.14c-53.059-53.125-53.059-139.237.066-192.329s139.254-53.108 192.379.05l96.09 96.14c53.059 53.125 53.059 139.237-.066 192.329C1300.211 1353.369 1265.414 1366.634 1230.617 1366.634z" />
                </svg>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5 block dark:hidden"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M21 12.79A9 9 0 0 1 11.21 3a7 7 0 1 0 9.79 9.79z" />
                </svg>
              </button>
            </div>
            <div className="ml-3 relative">
              <div>
                <button
                  className="flex text-sm border-2 border-transparent rounded-full focus:outline-none focus:border-gray-300 transition duration-150 ease-in-out hover:border-gray-300"
                  id="user-menu"
                  aria-label="User menu"
                  aria-haspopup="true"
                  onClick={() => {
                    handleClick();
                  }}
                >
                  <Avatar
                    url={
                      avatarurl == ""
                        ? "https://ui-avatars.com/api/name=" +
                        aName +
                        "/?background=random"
                        : avatarurl
                    }
                  />
                </button>
              </div>
              <span
                onClick={() => {
                  optionSelection("request");
                }}
                className={
                  (!hidden ? "hidden" : "") +
                  "fixed top-14 left-0 right-0 bottom-0 h-full w-full"
                }
              />
              <Transition
                show={isOpen}
                enter="transition ease-out duration-200 transform"
                enterFrom="opacity-0 scale-50"
                enterTo="opacity-100 scale-100"
                leave="transition ease-in duration-200 transform"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-50"
              >
                <div
                  id="dropDown"
                  className="origin-top-right absolute right-0 mt-2.5 w-36 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 dark:bg-black dark:ring-gray-600"
                  role="menu"
                  aria-orientation="vertical"
                  aria-labelledby="user-menu"
                >
                  {/* <div className="py-2 pl-2 dark:bg-white/10 text-left sm:border-b sm:border-double sm:border-dashed dark:border-gray-500">
                    <div className="text-base font-medium leading-6 text-gray-800 dark:text-white">
                      {aName}
                    </div>
                    <div className="text-sm font-medium leading-5 text-gray-500"></div>
                  </div> */}

                  <div className={""}>
                    <div className="sm:border-t sm:border-dashed sm:border-gray-200 dark:border-gray-900 hover:dark:bg-white/10">
                      <Link
                        to="/dashboard/edit-agent-details"
                        onClick={() => {
                          optionSelection("request");
                        }}
                        className="flex gap-2 pl-2 py-2.5 text-sm dark:text-gray-300 leading-5 text-gray-700 hover:bg-gray-100 hover:dark:text-white dark:bg-white/10 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                      >
                        <svg
                          className="w-4 h-4 fill-current text-blue-400 dark:text-white mt-0.5"
                          viewBox="0 0 50 50"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            d="M 4 0 L 4 48 L 21 48 C 21.359375 48.003906 21.695313 47.816406 21.878906 47.503906 C 22.058594 47.191406 22.058594 46.808594 21.878906 46.496094 C 21.695313 46.183594 21.359375 45.996094 21 46 L 6 46 L 6 2 L 24 2 L 24 16 L 38 16 L 38 27 C 37.996094 27.359375 38.183594 27.695313 38.496094 27.878906 C 38.808594 28.058594 39.191406 28.058594 39.503906 27.878906 C 39.816406 27.695313 40.003906 27.359375 40 27 L 40 14.59375 L 39.71875 14.28125 L 25.71875 0.28125 L 25.40625 0 Z M 26 3.4375 L 36.5625 14 L 26 14 Z M 45.90625 24.90625 C 44.855469 24.90625 43.800781 25.292969 43 26.09375 L 42.3125 26.8125 L 42.34375 26.84375 L 26.90625 42.28125 C 26.777344 42.398438 26.679688 42.550781 26.625 42.71875 L 24.9375 48.71875 C 24.835938 49.066406 24.925781 49.441406 25.179688 49.703125 C 25.433594 49.960938 25.804688 50.0625 26.15625 49.96875 L 32.15625 48.375 C 32.324219 48.320313 32.476563 48.222656 32.59375 48.09375 L 48.40625 32.40625 C 48.53125 32.296875 48.628906 32.15625 48.6875 32 L 48.8125 31.90625 C 50.414063 30.304688 50.414063 27.695313 48.8125 26.09375 C 48.011719 25.292969 46.957031 24.90625 45.90625 24.90625 Z M 43.75 28.25 L 46.75 31.25 L 31.40625 46.5 L 28.46875 43.65625 L 28.5 43.53125 Z"
                          ></path>
                        </svg>
                        Edit Profile
                      </Link>
                    </div>

                    <div className="sm:border-t sm:border-dashed sm:border-gray-200 hover:dark:bg-white/10 dark:border-gray-400">
                      <Link
                        to="/"
                        onClick={() => {
                          optionSelection("request");
                        }}
                        className="flex gap-2 pl-2 py-2.5 text-sm dark:text-gray-300 leading-5 text-gray-700 hover:bg-gray-100 hover:dark:text-white dark:bg-white/10 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                      >
                        <svg
                          className="w-4 h-4 fill-current text-blue-500 dark:text-white mt-0.5"
                          viewBox="0 0 50 50"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            d="M 25 2 C 12.309534 2 2 12.309534 2 25 C 2 37.690466 12.309534 48 25 48 C 32.610275 48 39.366605 44.294736 43.550781 38.591797 A 1.0001 1.0001 0 1 0 41.939453 37.408203 C 38.117629 42.617264 31.961725 46 25 46 C 13.390466 46 4 36.609534 4 25 C 4 13.390466 13.390466 4 25 4 C 31.961725 4 38.117629 7.3827357 41.939453 12.591797 A 1.0001 1.0001 0 1 0 43.550781 11.408203 C 39.366605 5.7052643 32.610275 2 25 2 z M 38.990234 15.990234 A 1.0001 1.0001 0 0 0 38.292969 17.707031 L 44.585938 24 L 23 24 A 1.0001 1.0001 0 1 0 23 26 L 44.585938 26 L 38.292969 32.292969 A 1.0001 1.0001 0 1 0 39.707031 33.707031 L 47.619141 25.794922 A 1.0001 1.0001 0 0 0 47.617188 24.203125 L 39.707031 16.292969 A 1.0001 1.0001 0 0 0 38.990234 15.990234 z"
                          ></path>
                        </svg>
                        Sign out
                      </Link>
                    </div>
                  </div>
                </div>
              </Transition>
            </div>
          </div>
          <div className="-mr-2 flex items-center sm:hidden">
            {/* Mobile menu button */}
            <button
              onClick={() => {
                handleClick();
              }}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out"
            >
              <svg
                className="block h-6 w-6"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
              {/* Menu open: "block", Menu closed: "hidden" */}
              <svg
                className="hidden h-6 w-6"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <Transition
        show={isOpen}
        enter="transition ease-out duration-100 transform"
        enterFrom="opacity-0 scale-95"
        enterTo="opacity-100 scale-100"
        leave="transition ease-in duration-75 transform"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95"
      >
        <div className="block sm:hidden">
          <div className="pt-4 pb-3 border-t border-gray-200">
            <div className="flex items-center px-4">
              <div className="flex-shrink-0"></div>
              <Avatar
                url={
                  avatarurl == ""
                    ? "https://ui-avatars.com/api/name=" +
                    aName +
                    "/?background=random"
                    : avatarurl
                }
              />
              <div className="ml-3">
                <div className="text-base font-medium leading-6 text-gray-800">
                  {aName}
                </div>
                <div className="text-sm font-medium leading-5 text-gray-500"></div>
              </div>
            </div>
            <div
              className="mt-3"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="user-menu"
            >
              <Link
                to="/"
                onClick={() => {
                  optionSelection("request");
                }}
                className="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
              >
                Sign out
              </Link>
            </div>
          </div>
        </div>
      </Transition>
    </nav>
  );
};

export default NavBar;
